import React, { useState, useEffect } from 'react';
import { Form, Button, Card, Alert, Modal, Spinner, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { FaTrashAlt } from 'react-icons/fa';
import useSWR, { mutate } from 'swr';
import { fetal as dbfetal } from '../../../helpers/laudos/fetal';
import { liberarLaudoByPac } from '../../../services/prontuario';
import CustomFileInput from '../../../components/CustomFileInput';
import generateFetalPDF from './generateFetalPDF';
import useUploadFiles from '../../../hooks/useUploadFiles';
import { selectFetalById, updateFetalById } from '../../../services/fetal';
import FontScaleButtonGroup from '../../../components/FontScaleButtonGroup';
import Footer from '../../../components/laudos/Footer';
import FileCarousel from '../../../components/laudos/FileCarousel';
import useViewFiles from '../../../hooks/useViewFiles';
import LaudoCardHeader from '../../../components/laudos/LaudoCardHeader';

export default function FormFetal() {
  const location = useLocation();
  const codFetal = location.state?.codLaudo;
  const { data, error, isLoading } = useSWR(
    codFetal ? `fetal-${codFetal}` : null,
    () => selectFetalById(codFetal)
  );
  const [fetalLaudo, setFetalLaudo] = useState(null);
  const [fontScale, setFontScale] = useState(1);
  const {
    urls,
    setURLs,
    loadingFiles,
    showModal: showFilesModal,
    setShowModal: setShowFilesModal,
    showFiles,
  } = useViewFiles({
    codLaudo: fetalLaudo?.CODFETAL,
    procedimento: 'fetal',
  });

  // NOVO: Estado para controlar a quebra de página
  // Opções: 'aorta', 'ducto', 'sem'
  const [quebraPagina, setQuebraPagina] = useState('sem');

  const {
    files: filesToUpload,
    setFiles: setFilesToUpload,
    showUpload,
    setShowUpload,
    isUploading,
    confirmUpload,
    handleCloseModal,
  } = useUploadFiles({ atividade: fetalLaudo });

  useEffect(() => {
    if (data) setFetalLaudo(data);
  }, [data]);

  const handleTipoFetal = tipo => {
    switch (tipo) {
      case 'normal':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[0].normal,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 't4f':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[2].t4f,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'sceh':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[3].sceh,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'dsavt':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[4].dsavt,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'coao':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[5].coao,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'civ':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[6].civ,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'tga':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[7].tga,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'dtga':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[8].dtga,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'ltga':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[9].ltga,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'dvsvdTaussig':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[10].dvsvdTaussig,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'dvsvd':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[11].dvsvd,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'ebstein':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[12].ebstein,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'atresiaI':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[13].atresiaI,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      case 'atresiaII':
        setFetalLaudo({
          ...fetalLaudo,
          DESCRICAO: dbfetal[14].atresiaII,
          TIPOFETAL: tipo,
        });
        document.getElementById('editDescricao').focus();
        break;
      default:
    }
  };

  const handleGravar = async (event, tipo) => {
    try {
      event.preventDefault();
      const res = await updateFetalById(fetalLaudo);
      if (tipo === 'definitivo') {
        const fatura = {
          codLaudo: fetalLaudo.CODFETAL,
          codPac: fetalLaudo.CODPAC,
        };
        await liberarLaudoByPac({ fatura });
        toast.success(res.message);
        mutate(`fetal-${fetalLaudo.CODFETAL}`);
        return;
      }
      toast.success(res.message);
      mutate(`fetal-${fetalLaudo.CODFETAL}`);
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Erro ao gravar fetal!');
    }
  };

  if (error) {
    return (
      <Alert variant="danger" style={{ marginTop: 10 }}>
        <Alert.Heading>Erro ao carregar laudo de fetal!</Alert.Heading>
        <p>Tente novamente.</p>
      </Alert>
    );
  }

  if (isLoading || !fetalLaudo) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh',
        }}
      >
        <Spinner animation="border" variant="dark" size="lg" />
      </div>
    );
  }

  return (
    <>
      <Card style={{ marginTop: 10 }}>
        <LaudoCardHeader title="ECOCARDIOGRAMA FETAL" />
        <Card.Body>
          <Form noValidate>
            <strong className="mr-auto">Nome do Paciente: </strong>
            {`${fetalLaudo.CODPAC} - ${fetalLaudo.NOMEPAC}`}
            <br />
            <strong className="mr-auto">Data de Nasc: </strong>
            {`${fetalLaudo.dataNasc}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Sexo: </strong>
            {`${fetalLaudo.SEXOPAC}`}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Idade: </strong>
            {`${fetalLaudo.idadePAC} anos`}
            <br />
            <strong className="mr-auto">Convênio: </strong>
            {fetalLaudo.SIGLACONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Cod FETAL: </strong>
            {fetalLaudo.CODFETAL}&nbsp;&nbsp;&nbsp;
            <strong className="mr-auto">Data do Exame: </strong>
            {fetalLaudo.dataFetal}
            <br />
            <strong className="mr-auto">Médico que Realizou: Dr. </strong>
            {`${fetalLaudo.Realizou}`}
            <br />
            <strong className="mr-auto">Médico que Solicitou: Dr. </strong>
            {`${fetalLaudo.Solicitou}`}

            <Card className="p-1 mt-2" style={{ fontSize: 12 }}>
              <strong>ECO FETAL</strong>
              <Row>
                <Col>
                  <Form.Check
                    label="Fetal Regular NORMAL"
                    name="groupFetal"
                    type="radio"
                    id="normal"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                  <Form.Check
                    label="Fetal TGA"
                    name="groupFetal"
                    type="radio"
                    id="tga"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                  <Form.Check
                    label="Fetal CIV"
                    name="groupFetal"
                    type="radio"
                    id="civ"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                  <Form.Check
                    label="Fetal COAO"
                    name="groupFetal"
                    type="radio"
                    id="coao"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                  <Form.Check
                    label="Fetal DSAVT"
                    name="groupFetal"
                    type="radio"
                    id="dsavt"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                  <Form.Check
                    label="Fetal SCEH"
                    name="groupFetal"
                    type="radio"
                    id="sceh"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                  <Form.Check
                    label="Fetal T4F"
                    name="groupFetal"
                    type="radio"
                    id="t4f"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                </Col>
                <Col>
                  <Form.Check
                    label="Fetal D-TGA"
                    name="groupFetal"
                    type="radio"
                    id="dtga"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                  <Form.Check
                    label="Fetal L-TGA"
                    name="groupFetal"
                    type="radio"
                    id="ltga"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                  <Form.Check
                    label="Fetal DVSVD Taussig Bing"
                    name="groupFetal"
                    type="radio"
                    id="dvsvdTaussig"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                  <Form.Check
                    label="Fetal DVSVD"
                    name="groupFetal"
                    type="radio"
                    id="dvsvd"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                  <Form.Check
                    label="Fetal Ebstein"
                    name="groupFetal"
                    type="radio"
                    id="ebstein"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                  <Form.Check
                    label="Fetal Atresia I"
                    name="groupFetal"
                    type="radio"
                    id="atresiaI"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                  <Form.Check
                    label="Fetal Atresia II"
                    name="groupFetal"
                    type="radio"
                    id="atresiaII"
                    onClick={event => handleTipoFetal(event.target.id)}
                  />
                </Col>
              </Row>
            </Card>
            &nbsp;
            <Form.Group size="sm" controlId="editDescricao">
              <Form.Label>
                <strong>DESCRIÇÃO</strong>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={fetalLaudo?.DESCRICAO?.split('\n').length + 3 || 2}
                name="DESCRICAO"
                value={fetalLaudo.DESCRICAO ? fetalLaudo.DESCRICAO : ''}
                onChange={e =>
                  setFetalLaudo({
                    ...fetalLaudo,
                    DESCRICAO: e.target.value,
                  })
                }
                onKeyDown={e => {
                  if (e.key === 'F2') {
                    const posStart = fetalLaudo?.DESCRICAO?.indexOf('---') ?? 0;
                    const memoDESCRICAO = document.getElementById(
                      'editDescricao'
                    );
                    memoDESCRICAO.setSelectionRange(posStart, posStart + 3);
                  }
                }}
              />
            </Form.Group>
            <FontScaleButtonGroup
              fontScale={fontScale}
              setFontScale={setFontScale}
            />

            {/* NOVO: Bloco de Seleção para Quebra de Página */}
            <Card className="p-2 mt-2" style={{ fontSize: 12, backgroundColor: '#f8f9fa' }}>
              <strong>QUEBRA DE PÁGINA (PDF):</strong>
              <div className="d-flex align-items-center mt-1">
                <Form.Check
                  inline
                  label="AORTA"
                  name="groupQuebra"
                  type="radio"
                  id="quebraAorta"
                  checked={quebraPagina === 'aorta'}
                  onChange={() => setQuebraPagina('aorta')}
                />
                <Form.Check
                  inline
                  label="DUCTO ARTERIOSO"
                  name="groupQuebra"
                  type="radio"
                  id="quebraDucto"
                  checked={quebraPagina === 'ducto'}
                  onChange={() => setQuebraPagina('ducto')}
                />
                <Form.Check
                  inline
                  label="CONCLUSÃO"
                  name="groupQuebra"
                  type="radio"
                  id="quebraConclusao"
                  checked={quebraPagina === 'quebraConclusao'}
                  onChange={() => setQuebraPagina('quebraConclusao')}
                />
                <Form.Check
                  inline
                  label="SEM QUEBRA"
                  name="groupQuebra"
                  type="radio"
                  id="quebraSem"
                  checked={quebraPagina === 'sem'}
                  onChange={() => setQuebraPagina('sem')}
                />
              </div>
            </Card>
            <Footer
              gravarParcial={e => handleGravar(e, 'parcial')}
              gravarDefinitivo={e => handleGravar(e, 'definitivo')}
              imprimirPdfNormal={() =>
                generateFetalPDF(fetalLaudo, 'imprimirNormal', fontScale, quebraPagina)
              }
              imprimirPdfTimbrado={() =>
                generateFetalPDF(fetalLaudo, 'imprimirTimbrado', fontScale, quebraPagina)
              }
              enviarPorWpp={() =>
                generateFetalPDF(fetalLaudo, 'envioWpp', fontScale, quebraPagina)
              }
              verImagens={showFiles}
              abrirUploadModal={() => setShowUpload(true)}
              laudo={fetalLaudo}
            />
          </Form>
        </Card.Body>
      </Card>

      <Modal
        show={showFilesModal}
        onHide={() => setShowFilesModal(false)}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Imagens</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingFiles ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '50vh',
              }}
            >
              <Spinner animation="border" variant="dark" size="lg" />
            </div>
          ) : (
            <FileCarousel urls={urls} setURLs={setURLs} />
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showUpload} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Anexar arquivo</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CustomFileInput
            id="file-upload"
            label="Selecionar arquivo"
            multiple={true}
            onChange={e => setFilesToUpload(Array.from(e.target.files))}
          />
          <ul>
            {filesToUpload?.map((file, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center' }}>
                <li style={{ marginRight: 5 }}>{file.name}</li>
                <FaTrashAlt
                  onClick={() =>
                    setFilesToUpload(f => f.filter((_, i) => i !== idx))
                  }
                  cursor="pointer"
                  style={{ color: 'red' }}
                />
              </div>
            ))}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          {isUploading ? (
            <Spinner animation="border" variant="dark" />
          ) : (
            <Button onClick={confirmUpload}>Confirmar</Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}
